/* eslint-disable @next/next/no-img-element */
// @ts-nocheck
"use client"
import { Box, Button, CircularProgress, SxProps, Typography } from "@mui/material"
import ImageIcon from "@mui/icons-material/Image"
import { useEffect, useState } from "react"
import { useMutation } from "react-query"
import { apiClient } from "@/apiClient/apiService"
import ApiEndpoints, { ROUTES } from "@/apiClient/apiEndpoints"
import { toast } from "react-toastify"
import { COLORS } from "@/theme/localTheme"
import { UPLOAD_IMAGE_SIZE } from "@/utils/constants/globalVariables"
import { blobToFile, checkFileSize } from "@/utils/CommonFunctions"
import { useImageFileUpload } from "@/hooks"

interface ImageUpload {
  name: string
  image: object
}

const validateFileWithSize = checkFileSize(UPLOAD_IMAGE_SIZE)

const AddImage = ({
  onFilesSelected,
  parentSelectedFilesLength,
  btnVariant = "contained",
  btnSxProps,
}: {
  onFilesSelected?: any
  parentSelectedFilesLength: number
  btnVariant?: string
  btnSxProps?: SxProps
}) => {

  const [_, setImageUrls] = useState<string[]>([])
  const [selectedFiles, setSelectedFiles] = useState<any[]>([])
  const [uploadedImages, setUploadedImages] = useState<Array<{url: string; uploaded_at?: EpochTimeStamp}>>([])

  const { isLoading, errorMessage, fileUploadHandler } = useImageFileUpload({
    maxNumOfImages: 5,
    numOfAlreadyUploaded: parentSelectedFilesLength,
    onSuccess: (data) => {
      if(data.image_url) {
        setImageUrls((prevUrls) => [...prevUrls, data.image_url])
        setSelectedFiles((prevFiles) => [...prevFiles, data.image_url])
        onFilesSelected((prevFiles) => [...prevFiles,  data.image_url])
        setUploadedImages(prev => [...prev, {url: data.image_url, uploaded_at: data.uploaded_at}])
      }
    }
  })

  return (
    <>
      <Box display={"flex"} flexDirection={"column"}>
        <Button
          startIcon={isLoading ? <CircularProgress size="1.4rem" /> : <ImageIcon />}
          disabled={isLoading}
          component="label"
          variant={btnVariant}
          htmlFor="account-settings-upload-image"
          sx={
            btnSxProps
              ? btnSxProps
              : {
                width: "11.375rem",
                color: "#fff",
                backgroundColor: "#2A7221",
                "&:hover": {
                  backgroundColor: "#2A7221",
                },
                height: "2.75rem",
              }
          }
        >
          Upload Images
          <input
            type="file"
            accept="image/*"
            onChange={fileUploadHandler}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              whiteSpace: "nowrap",
              opacity: "0",
              cursor: "pointer",
            }}
            multiple
          />
        </Button>
        {errorMessage && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
              color: "red",
            }}
          >
            <Typography sx={{ color: "red" }}>{errorMessage}</Typography>
          </Box>
        )}
      </Box>
    </>
  )
}

export default AddImage
